enum ESocialLinks {
  TELEGRAM = "TELEGRAM",
  TWITTER = "TWITTER",
  DISCORD = "DISCORD",
  YOUTUBE = "YOUTUBE",
  LINKEDIN = "LINKEDIN",
  PRIVACY_POLICY = "PRIVACY_POLICY",
  TERMS_OF_SERVICE = "TERMS_OF_SERVICE",
}

enum EAlphaLinks {
  HOME = "HOME",
  APPLICATION = "APPLICATION",
  BLOG = "BLOG",
  BUILD_KARMA = "BUILD_KARMA",
  MYSTERY_BOX = "MYSTERY_BOX",
  IDO = "IDO",
  CLAIM = "CLAIM",
  NFT = "NFT",
}

export const socialLinks: Record<ESocialLinks, string> = {
  [ESocialLinks.TELEGRAM]: "https://t.me/alphamind_official",
  [ESocialLinks.TWITTER]: "https://x.com/alphamind_labs",
  [ESocialLinks.DISCORD]: "https://discord.com/invite/NB4hhuXkWz",
  [ESocialLinks.YOUTUBE]: "https://www.youtube.com/@AlphaMind_labs",
  [ESocialLinks.LINKEDIN]:
    "https://www.linkedin.com/company/alphamindofficial/",
  [ESocialLinks.PRIVACY_POLICY]: "https://alphamind.co/privacy-policy",
  [ESocialLinks.TERMS_OF_SERVICE]: "https://alphamind.co/terms-of-service",
};

export const alphaLinks: Record<EAlphaLinks, string> = {
  [EAlphaLinks.HOME]: "https://alphamind.co/",
  [EAlphaLinks.APPLICATION]: "https://alphamind.co/application",
  [EAlphaLinks.BLOG]: "https://blog.alphamind.co/",
  [EAlphaLinks.BUILD_KARMA]: `https://app.alphamind.co/build_karma/`,
  [EAlphaLinks.MYSTERY_BOX]: "https://mystery.alphamind.co/",
  [EAlphaLinks.IDO]: "https://app.alphamind.co",
  [EAlphaLinks.CLAIM]: "https://app.alphamind.co/claim",
  [EAlphaLinks.NFT]: "https://alphamind.co/nft",
};

export const youtubeBridgeGuideLink =
  "https://www.youtube.com/embed/BnBabfYqNAI";

export const exampleLink =
  "https://media.alphamind.co/backgrounds/sbx/image.jpg";
